module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av174-535b516d2724cf507337e4e8aed14137.jpg";